// Convenzione UTM unica dell'ecosistema (vedi MASTER_ORCHESTRATION).
// ?utm_source=<youtube|instagram|facebook|newsletter>&utm_medium=<video|short|carousel|email>&utm_campaign=<tema, es. ocf-ep17>

export function buildUtm({ source, medium, campaign } = {}) {
  const p = new URLSearchParams();
  if (source) p.set("utm_source", source);
  if (medium) p.set("utm_medium", medium);
  if (campaign) p.set("utm_campaign", campaign);
  return p.toString();
}

export function withUtm(url, params) {
  const qs = buildUtm(params);
  if (!qs) return url;
  return url + (url.includes("?") ? "&" : "?") + qs;
}

// es: withUtm("/it/tools", { source: "youtube", medium: "video", campaign: "ocf-ep17" })
//  -> "/it/tools?utm_source=youtube&utm_medium=video&utm_campaign=ocf-ep17"
